<template>
  <request-form @close="onClose" />
</template>
<script>
import RequestForm from './CachePoliciesForm.vue'

export default {
  name: 'RequestPolicyCreate',
  components: { RequestForm },
  methods: {
    onClose() {
      this.$router.push({ name: 'cache-policies' })
    },
  },
}
</script>
